import { render, staticRenderFns } from "./AutreSituation.vue?vue&type=template&id=181dd156"
import script from "./AutreSituation.vue?vue&type=script&lang=js"
export * from "./AutreSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports